import { createFileRoute } from "@tanstack/react-router";
import { EmptyState } from "@bfc-software/pallet";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";

import { useManageTenant } from "../../-data/use-manage-tenant";

/** Placeholder: this screen is not built yet. */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/deliver/manage/$tenant/settings",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { tenant } = useManageTenant();
  const { t } = useTranslation({
    lang: params.lang,
    namespace: TRANSLATION_NAMESPACE.deliver,
  });

  return (
    <div className="bg-surface h-full w-full">
      <div className="page-shell">
        <header className="page-header">
          <div className="page-header-left">
            <h1 className="page-title">{t("manage.settings.heading")}</h1>
            <p className="page-subtitle">
              {tenant?.name} — {tenant?.warehouseCode}
            </p>
          </div>
        </header>
        <EmptyState heading={t("manage.comingSoon")} />
      </div>
    </div>
  );
}
